// extracted by mini-css-extract-plugin
export var dividerContainer = "_7f-0";
export var line = "_7f-1";